import { ConvBatchNorm } from './convBatchnorm';
import { ConvRelu } from './convRelu';
import { ConvRelu6 } from './convRelu6';
export const defaultOptimizations = [
    new ConvBatchNorm(),
    new ConvRelu(),
    new ConvRelu6(),
];
//# sourceMappingURL=default.js.map